class @App.Components.UserControls
  constructor: ->
    $(document).on 'click', '[data-dropdown="toggle"][href="#usermenu"]', (e) =>
      # Let the parent window know when this is opened/closed 
      # so it can alter z-index of the iframe
      window.parent.postMessage({
        event: 'user_action_dropdown_toggle',
        status: status 
      }, 'https://blog.ed.ted.com')

$ ->
  # We're in the blog header
  if $('.iframed-blog-header').length
    new App.Components.UserControls
